module.exports = __webpack_public_path__ + "img/12.9762786f.jpg";